module.exports = __webpack_public_path__ + "static/feature-recap-01-fadca4f8c6b128a24a88b8bde19cb843.svg";